import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

export default function ConfirmBeforeActionDialog(props) {

  const parentOnProceed = props.onProceed?props.onProceed:() => {}
  const parentOnCancel = props.onCancel?props.onCancel:() => {}
  const title = props.title?props.title:"Confirm Delete"
  const confirmMessage = props.confirmMessage?props.confirmMessage:"Please confirm you want to delete this record"
  const proceedButtonLabel = props.proceedButtonLabel?props.proceedButtonLabel:"Confirm"
  const cancelButtonLabel = props.cancelButtonLabel?props.cancelButtonLabel:"Cancel"
  // When set (e.g. "delete"), the user must type this keyword before Proceed
  // enables — an AWS-style guard for destructive, non-recoverable actions.
  const confirmKeyword = props.confirmKeyword || null
  const destructive = props.destructive || !!confirmKeyword
  // Optionally surface the specific entity being acted on (e.g. the case name)
  // in bold so the user can confirm they didn't click the wrong row.
  // getEntityName receives the data passed to handleConfirmAction.
  const entityNamePrefix = props.entityNamePrefix || "You are about to act on the following:"
  const entityName = props.getEntityName ? props.getEntityName(props.data) : null

  const [typed, setTyped] = React.useState("");

  // Reset the typed confirmation each time the dialog opens so a prior attempt
  // never leaves Proceed pre-enabled.
  React.useEffect(() => {
    if (props.open) {
      setTyped("");
    }
  }, [props.open]);

  const keywordSatisfied =
    !confirmKeyword || typed.trim().toLowerCase() === confirmKeyword.toLowerCase();

  const handleCancel = () => {
    parentOnCancel()
  };

  const handleProceed = () => {
    if (!keywordSatisfied) {
      return;
    }
    parentOnProceed()
  };

  return (
    <React.Fragment>

      <Dialog
        open={props.open}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          {entityName && (
            <div style={{ marginBottom: 'var(--space-4)' }}>
              <DialogContentText component="div" sx={{ mb: 'var(--space-1)' }}>
                {entityNamePrefix}
              </DialogContentText>
              <div
                style={{
                  padding: 'var(--space-2) var(--space-3)',
                  background: 'var(--surface-secondary)',
                  borderRadius: 'var(--radius-md)',
                  fontFamily: 'var(--font-display)',
                  fontWeight: 700,
                  fontSize: 'var(--text-lg)',
                  color: 'var(--text-primary)',
                  wordBreak: 'break-word',
                }}
              >
                {entityName}
              </div>
            </div>
          )}
          <DialogContentText id="alert-dialog-description">
            {confirmMessage}
          </DialogContentText>
          <props.list_element data={[props.data]}></props.list_element>
          {confirmKeyword && (
            <TextField
              autoFocus
              fullWidth
              size="small"
              margin="dense"
              value={typed}
              onChange={(e) => setTyped(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && keywordSatisfied) {
                  handleProceed();
                }
              }}
              label={`Type "${confirmKeyword}" to confirm`}
              placeholder={confirmKeyword}
              inputProps={{ 'aria-label': `Type ${confirmKeyword} to confirm` }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} autoFocus={!confirmKeyword}>{cancelButtonLabel}</Button>
          <Button
            onClick={handleProceed}
            disabled={!keywordSatisfied}
            color={destructive ? "error" : "primary"}
            variant={destructive ? "contained" : "text"}
          >
            {proceedButtonLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
